export const exams_index = ['tuevs_exams.index']
export const exams_create = ['tuevs_exams.create']
export const exams_edit = ['tuevs_exams.edit']

export default [].concat(
    exams_index,
    exams_create,
    exams_edit
)
